import React from 'react';
import { Box, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const RefreshButton = ({ onRefresh, loading = false }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-end',
      }}
    >
      <Button 
        startIcon={<RefreshIcon />} 
        onClick={onRefresh} 
        disabled={loading}
        variant="contained"
        sx={{
          borderRadius: 1,
            px: 3,
            py: 1.5,
            fontWeight: 600,
            fontSize: '0.875rem',
            bgcolor: '#1f1f1f',
            color: '#fff',
            textTransform: 'none',
            width: { xs: '100%', sm: 'auto' },
            '&:hover': {
              bgcolor: '#0F172A',
            },
        }}
      >
        Refresh
      </Button>
    </Box>
  );
};

export default RefreshButton;
